// src/services/authService.ts

import axios from 'axios';
import config from '../utils/config';

interface LoginResponse {
    access_token: string;
    token_type: string;
    // Include any other fields returned by the API
}

interface LoginData {
    email: string;
    password: string;
    role: string;
}

const authService = {
    login: async (data: LoginData): Promise<LoginResponse> => {
        try {
            const response = await axios.post<LoginResponse>(
                `${config.api.baseUrl}${config.api.endpoints.login}`,
                data
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    // You can add more auth-related methods here (e.g., logout, refreshToken)
};

export default authService;